import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

/**
 * Application entry point: bootstraps {@link AppComponent} with {@link appConfig}.
 *
 * Syncfusion licensing is handled at BUILD time (`npx syncfusion-license
 * activate`, run with the SYNCFUSION_LICENSE env var in the Dockerfile build
 * stage and the CI workflows), which patches the installed @syncfusion packages
 * so no license key ships in the browser bundle. Do NOT reintroduce
 * `registerLicense()` here -- a key registered in code is readable in DevTools.
 * Note: the key is tied to the @syncfusion/* MAJOR version (currently 34.x);
 * regenerate the SYNCFUSION_LICENSE secret/env value whenever the packages
 * cross a major, or components render an "invalid license" banner.
 * Same mechanism as trpl-regtrack-angular-web -- see SYNCFUSION-LICENSING.md.
 */
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
